/* eslint-disable no-param-reassign */
/* eslint-disable react/forbid-prop-types */
import 'url-search-params-polyfill';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FileSaver from 'file-saver';

import { withRouter } from 'react-router-dom';
import uniqBy from 'lodash/uniqBy';
import sortBy from 'lodash/sortBy';
import transform from 'lodash/transform';
import isObject from 'lodash/isObject';
import Axios from 'axios';
import isEqual from 'lodash/isEqual';
import moment from 'moment';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Select, Modal, Button, message } from 'antd';
import {
  organizationForRegister,
  getRFQbyID,
  putRFQ,
  cancelRFQ,
  addNDA,
  addParticipants,
  getUpdatedParticipantGrid,
  handleRFQSubmit,
  removeParticipants,
  getNDAlist,
  addAttachment,
  removeAttachment,
  getAttachmentList,
} from './graphql';
import history from '../../config/history';
import { tomcatHost, cloudFrontCdnUrl, apiUrl } from '../../config/properties';

const Option = Select.Option;

export default function ContractRFQHOC(ContractRFQ) {
  class WrappedComponent extends Component {
    static propTypes = {
      location: PropTypes.object.isRequired,
      auth: PropTypes.shape({
        id: PropTypes.string,
        role: PropTypes.string,
        jwtToken: PropTypes.string,
        expiration: PropTypes.number,
        organizationId: PropTypes.string,
      }).isRequired,
      rfqStore: PropTypes.object.isRequired,
    };

    static initialState = {
      initialValues: {
        id: '',

        description: '',
        solNum: '',
        niin: '',
        partNum: '',
        partDesc: '',
        quoteDueDate: '',
        sampleDueDate: '',
        orderDueDate: '',
        qty: '',
        releaseQty: '',
        castingWt: '',
        toolingAvailable: '',
        sampleAvailable: '',
        machiningReq: '',
        toolingDesc: '',
        prefCastProc: '',
        secOpsReq: '',
        reqCastSpec: '',
        testingRqmts: '',
        comment: '',
        drawingNums: '',
        nda: {},
        ndaId: '1',
        ndaList: [],
        attachmentsList: [],
      },
      recipientName: null,

      participants: [],
      visible: false,
      cageCode: null,
      originalOrgList: null,
      numPages: 0,
      pageNumber: 1,
      showPdfModal: false,
      selectedNda: null,
      fileList: [],
      ndaAttachmentNames: [],
      attachmentNames: [],
      rfqId: null,
      readOnly: false,
      rfqStatus: null,
      loading: false,
      attachmentFileList: [],
    };

    state = WrappedComponent.initialState;

    async componentDidMount() {
      const urlParams = new URLSearchParams(this.props.location.search);
      console.log(urlParams);

      const rfqId = urlParams.get('rfq');
      const { id } = this.props.auth;
      try {
        if (rfqId) {
          this.setState({
            rfqId,
            loading: true,
          });
          // TODO: make it so they can't add recepients

          const res = await getRFQbyID(id, rfqId);
          console.log(res);
          if (!res.rfqDetails.rfq) {
            this.setState({ readOnly: true });
            // TODO: handle error and redirect
            message
              .error(
                'Oops, We Cannot Find this RFQ, Please Contact Support if Problem Persists',
                2.5,
              )
              .then(() => {
                history.goBack();
              });
            return;
          }
          if (res.rfqDetails.rfq.status !== 'Draft') {
            this.setState({ readOnly: true });
          }
          this.setState({ rfqStatus: res.rfqDetails.rfq.status });

          if (res.rfqDetails.rfq && res.rfqDetails.rfq.nda) {
            res.rfqDetails.rfq.ndaId = Object.keys(res.rfqDetails.rfq.nda)[0];
          }

          const linkedParticipants = this.linkParticipants(
            res.rfqDetails.participantsGrid,
          );
          console.log(res.rfqDetails.rfq);
          if (res.rfqDetails.rfq && res.rfqDetails.rfq.attachmentsList) {
            console.log(res.rfqDetails.rfq.attachmentsList);
          }
          console.log(res.rfqDetails.rfq.nda);
          this.setState({
            initialValues: res.rfqDetails.rfq,
            participants: linkedParticipants,
            loading: false,
          });
        } else {
          message
            .error(
              'Oops, We Cannot Find this RFQ, Please Contact Support if Problem Persists',
              2.5,
            )
            .then(() => {
              history.goBack();
            });
        }

        const listOfOrgNames = [];

        let res = await organizationForRegister('requested');
        if (!res) {
          res = {};
        }
        let res1 = await organizationForRegister('approved');
        if (!res1) {
          res1 = {};
        }
        console.log(res1.length);
        const orgList = sortBy([...res1, ...res], 'name');
        console.log(orgList);

        const uniqueOrgs = uniqBy(orgList, 'cageCode');

        /* eslint-disable consistent-return */
        /* eslint-disable array-callback-return */
        const arr = uniqueOrgs.map(organization => {
          if (!organization.name || !organization.cageCode) {
            console.log('here');
            return;
          }
          // return 'here';
          if (organization.cageCode !== 'O0000') {
            listOfOrgNames.push(
              organization.name.replace(/[^A-Z0-9]/gi, '').toLowerCase(),
            );
            return (
              <Option
                key={`${organization.cageCode}-${organization.name}`}
                value={organization.cageCode}
              >
                {organization.name}
              </Option>
            );
          }

          // /  return <Option />;
        });
        this.setState({
          organizationList: new Set(arr),
          originalOrgList: orgList,
        });
      } catch (error) {
        message
          .error(
            'Oops, We Cannot Find this RFQ, Please Contact Support if Problem Persists',
            2.5,
          )
          .then(() => {
            history.goBack();
          });
      }
    }

    linkParticipants = participants => {
      console.log(participants);
      if (participants) {
        console.log('here');
        const linkedParticipants = participants.map(participant => {
          console.log(participant);

          if (participant.status === 'Submitted') {
            const test = (
              <Button
                type="link"
                onClick={() => this.viewQuote(participant.quoteId)}
              >
                Ready for Review
              </Button>
            );
            participant.status = test;
          } else if (
            participant.status === 'Awarded' ||
            participant.status === 'Declined'
          ) {
            {
              const test = (
                <Button
                  type="link"
                  onClick={() => this.viewQuote(participant.quoteId)}
                >
                  {participant.status}
                </Button>
              );
              participant.status = test;
            }
          }
          return participant;
        });
        console.log(linkedParticipants);
        //   return linkedParticipants;
      }
      return participants;
    };

    addRecipient = async () => {
      try {
        const addRes = await addParticipants(
          this.props.auth.id,
          this.state.rfqId,
          [this.state.cageCode],
        );
        if (addRes.addParticipants.status !== 'success') {
          message.error(
            'Oops, something went wrong trying to add that Recipient, please try again',
          );
        }

        const res = await getUpdatedParticipantGrid(
          this.props.auth.id,
          this.state.rfqId,
        );

        this.setState({
          visible: false,
          cageCode: null,
          participants: res.rfqDetails.participantsGrid,
        });
      } catch (err) {
        message.error('Oops, something went wrong, please try again');
      }
    };

    _handleRecipientAdd = async () => {
      if (this.state.readOnly) {
        this.setState({
          visible: false,
        });
        Modal.confirm({
          title: 'Confirm adding Recipient?',
          icon: <CheckCircleOutlined style={{ color: '#2ebd38' }} />,
          content: `Send RFQ to ${this.state.recipientName}`,
          okText: 'Confirm',
          onOk: async () => {
            await this.addRecipient();
          },
          onCancel: () => {
            this.setState({
              visible: true,
            });
          },

          cancelText: 'Cancel',
        });
      } else {
        this.addRecipient();
      }
      // create recepient object and push it into the recepipents table
    };

    onDocumentLoadSuccess = async ({ numPages }) => {
      if (this.state.numPages !== numPages) {
        this.setState({
          numPages,
        });
      }
    };


    difference = (object, base) => {
      const changes = (object1, base1) =>
        transform(object1, (result, value, key) => {
          if (!isEqual(value, base1[key])) {
            result[key] =
              isObject(value) && isObject(base1[key])
                ? changes(value, base1[key])
                : value;
          }
        });
      return changes(object, base);
    };

    linkToConversation = messageId => {
      history.push(`/messagecenter?message=${messageId}`);
    };

    handleSelectedActions = (action, cellProps) => {
      console.log(action, cellProps);
      switch (action) {
        case 'delete':
          this._removeParticipants(cellProps.original.cage);
          break;
        case 'reply':
          this.linkToConversation(cellProps.original.convoId);
          break;
        default:
          break;
      }
    };

    _removeParticipants = async cage => {
      await removeParticipants(this.props.auth.id, this.state.rfqId, [cage]);

      const res = await getUpdatedParticipantGrid(
        this.props.auth.id,
        this.state.rfqId,
      );
      this.setState({
        visible: false,
        cageCode: null,
        participants: res.rfqDetails.participantsGrid,
      });

      // create recepient object and push it into the recepipents table
    };

    format = obj => {
      const arr = ['castingWt', 'qty', 'releaseQty'];

      Object.entries(obj).forEach(([key, value]) => {
        console.log(value);
        if (arr.includes(key) !== -1 && typeof value === 'string') {
          obj[key] = value.replace(/[&\/\\#,+()$~%'":*?<>{}]/g, '');
        }
      });
      return obj;
    };

    _updateRFQ = async (skipNotice = false) => {
      const urlParams = new URLSearchParams(this.props.location.search);
      const rfqObj = { ...this.format(this.state.initialValues) };
      console.log(rfqObj);

      rfqObj.userId = this.props.auth.id;
      rfqObj.rfqId = urlParams.get('rfq');
      try {
        const res = await putRFQ(rfqObj);
        if (res.PutRFQ === null || res.PutRFQ.status !== 'success') {
          message.error('Oops, something went wrong, please try again');
          return false;
        }

        if (res.PutRFQ.status === 'success') {
          console.log(skipNotice);
          if (!skipNotice) {
            message.success('Successfully Saved Changes');
          }

          return true;
        }
      } catch (error) {
        console.error('hey something went wrong', error);
        return false;
      }
    };

    _showModal = () => {
      this.setState({
        visible: true,
      });
    };

    _handleRecipientCancel = () => {
      this.setState({ cageCode: null, visible: false });
    };

    formatNiin = niin => {
      console.log('formatNiin');
      console.log(niin);
      console.log(niin.length);

      if (niin.length > 13) {
        return;
      }

      let displayValue = '';
      if (niin.length === 9) {
        for (let idx = 0; idx < niin.length; idx++) {
          if (idx === 2) {
            displayValue += '-';
          } else if (idx === 5) {
            displayValue += '-';
          }
          displayValue += niin[idx];
        }
      } else
        for (let idx = 0; idx < niin.length; idx++) {
          if (idx === 4) {
            displayValue += '-';
          } else if (idx === 6) {
            displayValue += '-';
          } else if (idx === 9) {
            displayValue += '-';
          }
          displayValue += niin[idx];
        }
      return displayValue;

    };

    _handleFormSubmit = e => {
      console.log(e);
      const currentChange = this.difference(e, this.state.initialValues);
      console.log(currentChange);
      if (currentChange.niin) {
        const valueWithoutDashes = currentChange.niin.split('-').join('');

        const niin = this.formatNiin(valueWithoutDashes);
        e.niin = niin;
      }
      if (currentChange.solNum) {
        if (
          currentChange.solNum.length === 13 &&
          currentChange.solNum === 'SPE4A521T4227'
        ) {
          // TODO: make network call for solicitation info and auto poupulate
          console.log('were going to make a request here');
        }
      }
      this.setState({
        initialValues: e,
      });
    };

    _onRecipientSelect = async (value, obj) => {
      this.setState({
        cageCode: value,
        recipientName: obj.children,
      });
    };

    _discardChanges = async () => {
      const res = await getRFQbyID(this.props.auth.id, this.state.rfqId);
      console.log(res.rfqDetails);
      if (!res.rfqDetails.rfq) {
        // TODO: handle error and redirect
        return;
      }
      if (res.rfqDetails.rfq && res.rfqDetails.rfq.nda) {
        res.rfqDetails.rfq.ndaId = Object.keys(res.rfqDetails.rfq.nda)[0];
      }
      console.log(res.rfqDetails.rfq.nda);
      this.setState({
        initialValues: res.rfqDetails.rfq,
        participants: res.rfqDetails.participantsGrid,
      });
    };

    viewQuote = quoteId => {
      console.log(quoteId);
      const urlParams = new URLSearchParams(this.props.location.search);
      const rfqId = urlParams.get('rfq');
      history.push(`/contractcenter/review?quote=${quoteId}&rfq=${rfqId}`);
    };

    cageArray = () => {
      const participants = [...this.state.participants];

      const cages = participants.map(participantObj => participantObj.cage);
      return cages;
    };

    pick = (obj, keys) =>
      keys
        .map(k => (k in obj ? { [k]: obj[k] } : {}))
        .reduce((res, o) => Object.assign(res, o), {});

    submitRFQ = async () => {
      const success = await this._updateRFQ(true);
      if (!success) {
        return;
      }
      const participants = this.cageArray();

      const rfqId = this.state.rfqId;
      const userId = this.props.auth.id;
      let hasErrors = false;
      console.log(this.state.initialValues);

      const requiredFields = this.pick(this.state.initialValues, [
        'quoteDueDate',
        'orderDueDate',
        'qty',
        'description',
      ]);
      console.log(requiredFields);

      Object.values(requiredFields).some(element => {
        if (!element) {
          hasErrors = true;
          message.error('Please fill out the missing Fields');
          return true;
        }
      });

      if (!participants[0]) {
        // throw error
        hasErrors = true;
        message.error('Please add Recipients');
      }

      if (!hasErrors) {
        const res = await handleRFQSubmit(userId, rfqId, participants);
        if (res.handleRFQSubmit.status === 'success') {
          message.success('Successfully Sent RFQ').then(() => {
            history.goBack();
          });
        } else {
          message.error(
            'Oops, Something Went Wrong While Submitting RFQ Please Try Again or Contact Support if Problem Persists',
          );
        }
      }
    };

    _confirmRfqSubmit = () => {
      Modal.confirm({
        title: 'Confirm Submittal?',
        icon: <CheckCircleOutlined style={{ color: '#2ebd38' }} />,
        content: 'Your RFQ will be sent to all listed recipients',
        okText: 'Confirm',
        onOk: async () => {
          console.log(this.state.initialValues);
          this.submitRFQ();
        },
        onCancel: () => {
          console.log('test2');
        },

        cancelText: 'Cancel',
      });
    };

    cancelRFQ = async () => {
      const res = await cancelRFQ(this.props.auth.id, this.state.rfqId);
      console.log(res.cancelRFQ.status);
      if (res.cancelRFQ.status !== 'success') {
        message.error(
          'Something Went Wrong Trying to Cancel The RFQ, Please Try Again or Contact Support',
        );
      }
      if (res.cancelRFQ.status === 'success') {
        console.log('here');
        message.success('Successfully Cancelled RFQ').then(() => {
          history.goBack();
        });
      }
    };

    _confirmRfqCancel = () => {
      Modal.confirm({
        title: 'Cancel RFQ?',
        icon: <CloseCircleOutlined style={{ color: '#ff4d4f' }} />,
        content:
          'This will Cancel the RFQ and Notify any recipients of the decision.',
        okText: 'Confirm',
        onOk: async () => {
          this.cancelRFQ();
        },

        cancelText: 'Cancel',
      });
    };

    _changeDate = (e, value) => {
      console.log('change date why arent you working? ');
      const initialValuesCopy = { ...this.state.initialValues };
      const { name } = e;
      console.log(e, value);
      initialValuesCopy[name] = value;
      this.setState({
        initialValues: initialValuesCopy,
      });
    };

    createRecepientObject = recepipentsArray => {
      if (!this.state.originalOrgList) return [];
      const recepientObj = recepipentsArray.map(cage => {
        // TODO: check here and check the recepient Obj I get back from the service
        // const searchExistingRecepientsResult = this.searchCage(cage.trim(), this.state.existingRecepients)
        const searchResult = this.searchCage(
          cage.trim(),
          this.state.originalOrgList,
        );
        console.log(searchResult);
        const now = moment(new Date())
          .format('MM-DD-YYYY')
          .toLocaleString();

        const test = (
          <Button type="link" onClick={this.viewQuote}>
            waiting submittal
          </Button>
        );

        const obj = {
          name: searchResult.name || '',
          cage,
          quoteRequestDate: now,
          quoteDate: '',
          status: test,
        };
        return obj;
      });
      console.log(this.state.originalOrgList);

      return recepientObj;
    };

    searchCage = (nameKey, myArray) => {
      const obj = myArray.find(o => o.cageCode === nameKey);
      return obj;
    };

    changePage = offset =>
      this.setState(prevState => ({
        pageNumber: prevState.pageNumber + offset,
      }));

    previousPage = () => this.changePage(-1);
    nextPage = () => this.changePage(1);

    downloadNDA = async () => {
      try {
        const res = await Axios.get(

          `${cloudFrontCdnUrl}/${tomcatHost}/rfq/attachment/nda/${this.state.selectedNda || this.state.initialValues.ndaId}`,
          {
            responseType: 'blob',
            headers: {
              Authorization: `Bearer ${this.props.auth.jwtToken}`,
            }
          },
        );

        const data = res.data;

        // const a = document.createElement('a');
        // document.body.appendChild(a);
        // a.style = 'display: none';

        const blob = new Blob([data], { type: 'octet/stream' });
        console.log(blob, 'nda');
        if (navigator.msSaveBlob) {
          // For IE
          console.log('here');
          navigator.msSaveBlob(blob, 'NDA.pdf');
        } else {
          FileSaver.saveAs(blob, 'NDA.pdf');
        }
        //   const url = window.URL.createObjectURL(blob);
        //   a.href = url;
        //   a.download = attachmentName;
        //   a.click();
        //   window.URL.revokeObjectURL(url);
        //   return true;
      } catch (err) {
        console.log(err);
      }
    };

    viewPDF = () => {
      this.setState(prevState => ({
        showPdfModal: !prevState.showPdfModal,
      }));
    };

    _changeSelectValue = (e, value) => {
      console.log(e, value);
      const initialValuesCopy = { ...this.state.initialValues };
      const { name } = e;
      console.log(e, value);
      initialValuesCopy[name] = value;
      if (name === 'ndaId') {
        this.setState({
          selectedNda: value,
        });
      }
      this.setState({
        initialValues: initialValuesCopy,
      });
    };
    _handleUploadChange = info => {
      console.log(info);
      let fileList = [...info.fileList];
      if (info.file.size > 26214400) {
        console.log(info.file.uid);
        const arr = fileList.filter(obj => obj.uid !== info.file.uid);
        fileList = arr;
      }

      // 1. Limit the number of uploaded files
      // Only to show two recent uploaded files, and old ones will be replaced by the new
      // 2. Read from response and show file link

      if (fileList.length > 10) {
        fileList = fileList.slice(0, 10);
      }

      this.setState({ fileList });
    };

    _handleAttachmentUploadChange = async info => {
      let fileList = [...info.fileList];
      if (info.file.size > 26214400) {
        console.log(info.file.uid);
        const arr = fileList.filter(obj => obj.uid !== info.file.uid);
        fileList = arr;
      }

      // 1. Limit the number of uploaded files
      // Only to show two recent uploaded files, and old ones will be replaced by the new
      // 2. Read from response and show file link

      if (info.file === 'removed') {
        return;
      }
      if (fileList.length > 10) {
        fileList = fileList.slice(0, 10);
      }

      this.setState({ attachmentFileList: fileList });
    };

    _getPresignedPostData = async (selectedFile, type) => {
      const fileName = `${this.props.auth.id.replace(/-/g, '')}-${selectedFile.name
        }`;
      if (type === 'nda') {
        const ndaAttachmentNames = [...this.state.ndaAttachmentNames];
        ndaAttachmentNames.push(fileName);
        this.setState({
          ndaAttachmentNames,
        });
      } else {
        const attachmentNames = [...this.state.attachmentNames];
        attachmentNames.push(fileName);
        this.setState({
          attachmentNames,
        });
      }
      try {
        const res = await Axios.post(`${apiUrl}conversation/getpresignedUrl`, {
          name: fileName,
          type: selectedFile.type,
        });

        return res.data;
      } catch (error) {
        console.error(error);
      }
    };

    handleNDAUpload = async () => {
      const desc = this.state.ndaAttachmentNames[0].split('-');

      await addNDA(this.props.auth.id, desc[1], this.state.ndaAttachmentNames);

      const ndaList = await getNDAlist(this.props.auth.id, this.state.rfqId);
      const initialValues = { ...this.state.initialValues };

      initialValues.ndaList = ndaList.rfqDetails.rfq.ndaList;
      initialValues.nda = ndaList.rfqDetails.rfq.ndaList.slice(-1)[0];
      initialValues.ndaId = Object.keys(initialValues.nda)[0];
      const selectedNda = Object.keys(initialValues.nda)[0];
      this.setState({ initialValues, selectedNda, ndaAttachmentNames: [] });
    };

    handleAttachmentUpload = async () => {
      console.log('attachmentUpload');
      console.log(this.state.attachmentNames);

      const res = await addAttachment(
        this.props.auth.id,
        this.state.rfqId,
        this.state.attachmentNames,
      );
      console.log(res);

      // await this.getUpdatedAttachmentList(true);

      this.setState({
        attachmentNames: [],
      });
    };

    _handleUpload = async (option, type = 'nda') => {
      const { onSuccess, onError, file, onProgress } = option;
      const reader = new FileReader();
      if (file.size > 26214400) {
        return;
      }
      if (this.state.fileList.length > 10) {
        return;
      }
      onProgress({ percent: 1 }, file);
      reader.readAsDataURL(file);

      const presignedPostData = await this._getPresignedPostData(file, type);

      const fd = new FormData();
      Object.keys(presignedPostData.fields).forEach(key => {
        fd.append(key, presignedPostData.fields[key]);
      });

      // Actual file has to be appended last.
      fd.append('file', file);
      console.log(fd.values());

      const config = {
        url: `${presignedPostData.url}`,
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },

        data: fd,
        onUploadProgress: ({ total, loaded }) => {
          onProgress(
            { percent: Math.round((loaded / total) * 100).toFixed(2) },
            file,
          );
        },
      };

      try {
        await Axios(config);
        onSuccess(() => {
          console.log('I am successful');
        });

        if (type === 'nda') {
          await this.handleNDAUpload();
        } else {
          await this.handleAttachmentUpload();
        }
      } catch (error) {
        console.log(error);
        onError(error);
      }
    };

    getUpdatedAttachmentList = async (resetAttachmentList = false) => {
      if (resetAttachmentList) {
        this.setState({
          attachmentLoading: true,
        });
      }
      const attachments = await getAttachmentList(
        this.props.auth.id,
        this.state.rfqId,
      );
      console.log(attachments);
      if (attachments.rfqDetails.rfq) {
        const initialValues = { ...this.state.initialValues };
        console.log(initialValues);

        initialValues.attachmentsList =
          attachments.rfqDetails.rfq.attachmentsList;
        console.log(initialValues);

        this.setState({
          initialValues,
        });
      } else {
        message.error(
          'There Was a Problem Refreshing the Attachment List. Please Save and Refresh the page',
        );
      }
    };

    _removeAttachments = async attachmentId => {
      try {
        const res = await removeAttachment(
          this.props.auth.id,
          this.state.rfqId,
          attachmentId,
        );
        console.log(res);
        if (res.removeAttachment && res.removeAttachment.status === 'success') {
          this.getUpdatedAttachmentList();
        } else {
          message.error(
            'There Was a Problem Removing the Attachment. Please Wait and Try Again',
          );
        }
      } catch (err) {
        console.log(err);
        message.error(
          'There Was a Problem Removing the Attachment. Please Wait and Try Again',
        );
      }
    };

    render() {
      const {
        initialValues,
        organizationList,
        visible,
        numPages,
        pageNumber,
        showPdfModal,
        selectedNda,
        participants,
        readOnly,
        attachmentFileList,
      } = this.state;
      const pageProps = {
        auth: this.props.auth,
        visible,
        numPages,
        handleFormSubmit: this._handleFormSubmit,
        initialValues,
        organizationList,
        onRecipientSelect: this._onRecipientSelect,
        handleRecipientAdd: this._handleRecipientAdd,
        handleRecipientCancel: this._handleRecipientCancel,
        confirmRfqCancel: this._confirmRfqCancel,
        confirmRfqSubmit: this._confirmRfqSubmit,
        showModal: this._showModal,
        updateRFQ: this._updateRFQ,
        previousPage: this.previousPage,
        nextPage: this.nextPage,
        changeDate: this._changeDate,
        onDocumentLoadSuccess: this.onDocumentLoadSuccess,
        pageNumber,
        downloadNDA: this.downloadNDA,
        showPdfModal,
        selectedNda,
        attachmentFileList,
        viewPDF: this.viewPDF,
        handleUpload: this._handleUpload,
        changeSelectValue: this._changeSelectValue,
        handleUploadChange: this._handleUploadChange,
        participants,
        discardChanges: this._discardChanges,
        handleSelectedActions: this.handleSelectedActions,
        readOnly,
        handleAttachmentUploadChange: this._handleAttachmentUploadChange,
        removeAttachments: this._removeAttachments,
      };
      return <ContractRFQ {...pageProps} {...this.state} />;
    }
  }
  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/pages/contractRFQ/ContractRFQHOC.jsx